import React, { useState } from 'react';
import { Form, ListGroup, Pagination, Card } from 'react-bootstrap';


const StockSearch = ({ setSelectedStock, stocks }) => {
  const [query, setQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const filteredStocks = stocks.filter((stock) =>
    stock.name.toLowerCase().includes(query.toLowerCase()) ||
    stock.symbol.toLowerCase().includes(query.toLowerCase())
  );

  const totalPages = Math.ceil(filteredStocks.length / itemsPerPage);
  const paginatedStocks = filteredStocks.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPagination = () => {
    const paginationItems = [];
    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
    return paginationItems;
  };

  return (
    <Card className='my-4'>
      <Card.Header className='border-bottom p-3'>
        <Form.Control
          type="text"
          placeholder="Search stock..."
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setCurrentPage(1); // Reset to first page on new search
          }}
        />
      </Card.Header>
      <Card.Body className='p-1'>
        <ListGroup>
          {paginatedStocks.map((stock) => (
            <ListGroup.Item
              key={stock.symbol}
              onClick={() => setSelectedStock(stock.symbol)}
              style={{
                cursor: 'pointer'
              }}
            >
              {stock.name} ({stock.symbol})
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
      <Card.Footer className='border'>
        {totalPages > 1 && (
          <Pagination
            className="m-0"
            style={{
              overflowX: 'auto',
              margin: '0 auto'
            }}
          >{renderPagination()}</Pagination>
        )}
      </Card.Footer>
    </Card>
  );
};

export default StockSearch;
